import jquery from 'jquery-slim';

window.$ = window.jQuery = jquery;